export type ConfigProps = {
    Sidebar_drawer: any;
    Customizer_drawer: boolean;
    mini_sidebar: boolean;
    setHorizontalLayout: boolean;
    setRTLLayout: boolean;
    actTheme: string;
    boxed: boolean;
    setBorderCard: boolean;
    preloader: boolean;
};

const config: ConfigProps = {
    Sidebar_drawer: false, // Start with sidebar closed for horizontal layout
    Customizer_drawer: false,
    mini_sidebar: false,
    setHorizontalLayout: true, // Horizontal layout (top navigation bar)
    setRTLLayout: false, // RTL layout
    actTheme: 'BLUE_THEME',
    boxed: false,
    setBorderCard: false,
    preloader: false
};

export default config;
